import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const carouselContainer = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(6)};
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: relative;
`

export const carousel = css`
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
`

export const carouselControls = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  left: ${theme.spacing(-6)};
  right: ${theme.spacing(-6)};
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const carouselContent = css`
  display: flex;
  align-items: stretch;
  height: 100%;
  justify-content: center;
`

export const carouselCentered = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
`

export const carouselCenter = (calculatedChildWidth: number) => css`
  width: ${calculatedChildWidth}px;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
`

export const buttonStyle = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: ${theme.palette.background.paper};
  color: ${theme.palette.primary.main};
  transition:
    opacity 0.2s ease-in-out,
    background-color 0.2s ease-in-out;
  &:hover {
    background-color: ${theme.palette.primary[900]};
  }
  &:disabled {
    opacity: 0;
  }
`

export const leftButtonStyle = (theme: Theme) => css`
  left: 0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  z-index: 1;
  width: ${theme.spacing(12)};
  height: ${theme.spacing(12)};
`

export const rightButtonStyle = (theme: Theme) => css`
  right: 0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  z-index: 1;
  width: ${theme.spacing(12)};
  height: ${theme.spacing(12)};
`

export const dotsContainer = (theme: Theme) => css`
  display: flex;
  justify-content: center;
  gap: ${theme.spacing(1)};
`

export const dotStyle = (theme: Theme, isActive: boolean) => css`
  width: ${theme.spacing(4)};
  height: ${theme.spacing(4)};
  border-radius: 50%;
  background-color: ${isActive ? theme.palette.secondary.main : theme.palette.white.main};
  border: 1px solid ${theme.palette.secondary.main};
  cursor: pointer;
  transition:
    background-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
  &:hover {
    box-shadow: inset 0px 0px 0px 20px ${theme.palette.secondary.main}20;
  }
`

export const childWrapper = (
  index: number,
  repeatIndex: number,
  currentIndex: number,
  currentRepeatIndex: number,
  childrenLength: number,
  calculatedChildWidth: number,
  childGap: number,
) => {
  const trueIndex = index + repeatIndex * childrenLength
  const trueCurrentIndex = currentIndex + currentRepeatIndex * childrenLength
  return css`
    flex: 0 0 ${100 / childrenLength}%;
    left: ${(trueIndex - trueCurrentIndex) * calculatedChildWidth -
    childGap * (trueCurrentIndex - trueIndex)}px;
    position: absolute;
    transition:
      left 0.3s ease-in-out,
      max-width 0.1s linear,
      min-width 0.1s linear;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: ${calculatedChildWidth}px;
    min-width: ${calculatedChildWidth}px;
    height: 100%;
    overflow: hidden;
    perspective: 1000px;
  `
}
